import { combineReducers } from 'redux'
import subscription from './subscription'
import subscriptions from './subscriptions'
import dataHistory from './data-history'
import graph from './graph'

export default combineReducers({
  subscription,
  subscriptions,
  dataHistory,
  graph
})



// WEBPACK FOOTER //
// ./src/store/subscriptions-admin/index.js